import { useRouteError } from "react-router-dom";
import {useEffect} from "react";
import * as Sentry from "@sentry/react";

export default function ErrorPage() {
    const error = useRouteError();
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                <i>{error.statusText}</i>
                <i>{error.message}</i>
            </p>
        </div>
    );
}